"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignRequestToolbar = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const ButtonGroup_1 = __importDefault(require("@material-ui/core/ButtonGroup/ButtonGroup"));
const styles_1 = require("./styles");
const signing_types_1 = require("../signing-types");
const detail_context_1 = require("../../../composite/detail/detail-context");
const detail_toolbar_button_action_1 = require("../../../composite/detail/detail-toolbar-button-action");
const signing_api_1 = require("../signing-api");
const signing_context_1 = require("../signing-context");
const form_file_field_1 = require("../../../composite/form/fields/form-file-field");
const form_select_1 = require("../../../composite/form/fields/form-select");
const list_source_hook_1 = require("../../../utils/list-source-hook");
function SignRequestToolbar() {
    var _a, _b, _c, _d;
    const intl = react_intl_1.useIntl();
    const classes = styles_1.useStyles();
    const { source } = react_1.useContext(detail_context_1.DetailContext);
    const { url } = react_1.useContext(signing_context_1.SigningContext);
    const sign = react_1.useMemo(() => signing_api_1.signFactory(url), [url]);
    const uploadSignedContent = react_1.useMemo(() => signing_api_1.uploadSignedContentFactory(url), [
        url,
    ]);
    const contentsSource = list_source_hook_1.useStaticListSource((_b = (_a = source.data) === null || _a === void 0 ? void 0 : _a.contents) !== null && _b !== void 0 ? _b : []);
    const UploadSignedContentFields = react_1.useMemo(() => function UploadSignedContentFields() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(form_select_1.FormSelect, { name: "content", label: "K podeps\u00E1n\u00ED", source: contentsSource, labelMapper: (content) => { var _a, _b; return (_b = (_a = content.toSign) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; } }),
            react_1.default.createElement(form_file_field_1.FormFileField, { name: "signed", label: "Podepsan\u00FD soubor", required: true })));
    }, [contentsSource]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ButtonGroup_1.default, { size: "small", variant: "outlined", className: classes.toolbarIndentLeft },
                ((_c = source.data) === null || _c === void 0 ? void 0 : _c.state) === signing_types_1.SignRequestState.NEW && (react_1.default.createElement(detail_toolbar_button_action_1.DetailToolbarButtonAction, { promptKey: "SIGN_REQUEST_UPLOAD_SIGNED_CONTENT", apiCall: uploadSignedContent, formInitialValues: { content: null, signed: null }, FormFields: UploadSignedContentFields, buttonLabel: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_TOOLBAR_BTN_UPLOAD_SIGNED_CONTENT',
                        defaultMessage: 'Nahrát',
                    }), buttonTooltip: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_TOOLBAR_TOOLTIP_UPLOAD_SIGNED_CONTENT',
                        defaultMessage: 'Otevrě dialog s nahráním podepsané přílohy',
                    }), dialogTitle: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_UPLOAD_SIGNED_CONTENT_DIALOG_TITLE',
                        defaultMessage: 'Varování',
                    }), dialogText: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_UPLOAD_SIGNED_CONTENT_DIALOG_TEXT',
                        defaultMessage: 'Skutečně chcete označit požadavek za podepsaný ?',
                    }) })),
                ((_d = source.data) === null || _d === void 0 ? void 0 : _d.state) === signing_types_1.SignRequestState.NEW && (react_1.default.createElement(detail_toolbar_button_action_1.DetailToolbarButtonAction, { promptKey: "SIGN_REQUEST_SIGN", apiCall: sign, formInitialValues: { stampNumber: '' }, buttonLabel: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_TOOLBAR_BTN_SIGN',
                        defaultMessage: 'Podepsat',
                    }), buttonTooltip: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_TOOLBAR_TOOLTIP_SIGN',
                        defaultMessage: 'Otevrě dialog s potvrzením podepsání dokumentu',
                    }), dialogTitle: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_SIGN_DIALOG_TITLE',
                        defaultMessage: 'Varování',
                    }), dialogText: intl.formatMessage({
                        id: 'EAS_SIGN_REQUESTS_SIGN_DIALOG_TEXT',
                        defaultMessage: 'Skutečně chcete označit požadavek za podepsaný ?',
                    }) }))))));
}
exports.SignRequestToolbar = SignRequestToolbar;
//# sourceMappingURL=requests-detail-toolbar.js.map